module.exports = __webpack_public_path__ + "img/104-a9546b.png";